/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import QRCode from '@bitcoin-portal/bitcoincom-pkg-components/dist/QRCode';
import PropTypes from 'prop-types';
import { handleRipple } from '../../../helpers/ripple';
import {
  StyledSection,
  StyledContentBlock,
  Title,
  Subtitle,
  QrWrapper,
  ApptoreButton,
  GooglplayButton,
  MobileButton,
  // QrIcon,
  Icon,
  TotalImageWrapper,
  BackGroundWrapper,
  Contentwrapper,
  TotalImageWrapperTablet,
  TotalImageWrapperMobile,
  DesktopButton,
  StyledGatsbyLink,
} from './styled';

import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../../../components/QrCodeModalV2/styled';
import WalletsCreated from '../WalletsCreated';
import { useBranchLink } from '../../../helpers/branchLink';

const Header = ({ locale }) => {
  const { messages } = useIntl();
  const modalRef = useRef();
  const [selectedStore, setSelectedStore] = useState('GOOGLE_PLAY');

  const mobileButtonLink = useBranchLink({
    branch: messages['home.header.link.mobile_button'],
    android: messages['home.header.link.googleplay'],
    iOS: messages['home.header.link.appstore'],
    fallback: messages['home.header.link.mobile_button'],
  });

  const qrValue =
    selectedStore === 'GOOGLE_PLAY'
      ? messages['global.qrcodeModal.google-play.link']
      : messages['global.qrcodeModal.app-store.link'];

  const handleDesktopButtonClick = e => {
    e.preventDefault();

    window.location.href = '/download';
  };

  const handleMobileButtonClick = e => {
    e.preventDefault();

    window.location.href = '/download';
  };

  return (
    <StyledSection>
      <StyledContentBlock>
        <BackGroundWrapper>
          <TotalImageWrapper
            src={messages['home.header.hero_desktop']}
            alt={messages['home.header.title']}
          />
          <TotalImageWrapperTablet
            src={messages['home.header.hero_tablet']}
            alt={messages['home.header.title']}
          />
          <TotalImageWrapperMobile
            src={messages['home.header.hero_mobile']}
            alt={messages['home.header.title']}
          />
        </BackGroundWrapper>

        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id="home.header.title" />
          </Title>
          <Subtitle>
            <FormattedMessage id="home.header.subtitle" />
          </Subtitle>

          <QrWrapper>
            <DesktopButton
              onMouseEnter={handleRipple}
              onClick={() => modalRef.current.open()}
              className="ga-wallet-cta get-app-cta-button-2"
            >
              <FormattedMessage id="home.header.mobile_button" />
            </DesktopButton>
            <ApptoreButton
              href={messages['home.header.link.appstore']}
              target="_blank"
            >
              <Icon
                src={messages['home.header.appstore_image']}
                alt="App Store"
              />
            </ApptoreButton>

            <GooglplayButton
              href={messages['home.header.link.googleplay']}
              target="_blank"
            >
              <Icon
                src={messages['home.header.googleplay_image']}
                alt="Google Play"
              />
            </GooglplayButton>

            {/* <QrIcon
              className="ga-wallet-cta get-app-cta-button"
              onClick={() => modalRef.current?.open()}
              src={messages['home.header.qr_image']}
              alt="QR Code"
            /> */}
          </QrWrapper>
        </Contentwrapper>

        <MobileButton
          onMouseEnter={handleRipple}
          onClick={handleMobileButtonClick}
        >
          <FormattedMessage id="home.header.mobile_button" />
        </MobileButton>
        <ModalWrapper>
          <Modal ref={modalRef}>
            <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
            <StyledSubtitle>
              {messages['global.qrcodeModal.description']}
            </StyledSubtitle>
            {/* <StoreToggle
              selectedStore={selectedStore}
              setSelectedStore={setSelectedStore}
            /> */}
            <QrCodeWrapper>
              <div style={{ width: '100%' }}>
                <img
                  src="/images/uploads/download.png"
                  alt="QR Code to download Bitcoin.com Wallet"
                  style={{
                    width: '236px',
                    height: '236px',
                  }}
                />
              </div>
            </QrCodeWrapper>
            <StyledGatsbyLink
              to="https://support.bitcoin.com/en/articles/12380851-how-to-scan-a-qr-code"
              target="_blank"
            >
              {messages['global.qrcodeModal.support']}
            </StyledGatsbyLink>
          </Modal>
        </ModalWrapper>
      </StyledContentBlock>
      <WalletsCreated />
    </StyledSection>
  );
};

Header.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default Header;
